import React from 'react'
import * as blueprint from '@adc/blueprint'
import classnames from 'classnames/bind'
import styles from '../styles.scss'

const cx = classnames.bind(styles)

class FinanceContingency extends blueprint.listing.badges.FinanceContingency {
  get content() {
    return (
      <div>
        Protecting you while getting your loan:
        <ul className={cx('badge-bullet-list')}>
          <li>
            A finance contingency gives you time to secure your loan with
            confidence.
          </li>
          <li>You'll have time to work with your lender.</li>
          <li>If loan approval issues come up, you won't lose your deposit.</li>
          <li>We can help you by reminding you of relevant deadlines.</li>
          <li>
            You will remain responsible for completing all legal requirements
            for financing and timelines for closing.
          </li>
        </ul>
      </div>
    )
  }
}

class InspectionContigency extends blueprint.listing.badges
  .InspectionContigency {
  get content() {
    return (
      <div>
        Getting to know your potential home better:
        <ul className={cx('badge-bullet-list')}>
          <li>
            After your offer's accepted, hire a professional to inspect the
            home.
          </li>
          <li>
            Always obtain proper permission and follow all applicable laws and
            regulations when viewing properties.
          </li>
          <li>
            You can work with the seller to arrange a convenient time for you
            and your inspector to view the home.
          </li>
          <li>
            An inspector can help check everything from the roof to the
            foundation.
          </li>
          <li>You will have specified days to complete this step.</li>
          <li>
            Have any concerns? You'll have an opportunity to discuss the
            inspection information with the seller, as needed.
          </li>
        </ul>
      </div>
    )
  }
}
export { FinanceContingency, InspectionContigency }
